import * as React from 'react'
import { PageProps } from '@logic'
import { ViewProfileShared } from '@modules/profile/components/profile-details-shared'
import { signUpModal } from '@shared/components/modal'

type Props = PageProps

// Default empty data for guest mode
const guestProfileData = {
    profile: {
        fullName: 'Guest User',
        email: '',
        dateOfBirth: undefined,
        phoneCode: '',
        phoneNumber: '',
        links: {},
        website: '',
    },
    addresses: [],
    emails: [],
}

export const ViewGuestProfile = (props: Props) => {
    const { navigate } = props
    const signUpModalBundle = signUpModal({ navigate })

    return <>
        {signUpModalBundle.component}
        <ViewProfileShared
            {...props}
            {...guestProfileData}
            forGuest={true}
            openSignUp={() => signUpModalBundle.setVisible(true)}
        />
    </>
}
